module.exports = __webpack_public_path__ + "img/level_02_normal.af90b1de.svg";